import { render } from "./MediaflowEmptyPlaceholder.vue?vue&type=template&id=7cdce4bb"
import script from "./MediaflowEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowEmptyPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cdce4bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cdce4bb', __exports__)) {
    api.reload('7cdce4bb', __exports__)
  }
  
  module.hot.accept("./MediaflowEmptyPlaceholder.vue?vue&type=template&id=7cdce4bb", () => {
    api.rerender('7cdce4bb', render)
  })

}


export default __exports__